<template>
	<div>
		<SupportBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="column-center" v-if="info">
				<h3>자주하는 질문</h3>
				<div class="content-title" >
					【{{info.cate_name}}】{{info.title}}
				</div>
				<div class="content-date">
					{{info.createtime}} / {{info.nickname}}
				</div>
				<div class="content" v-html="info.content">
					
				</div>
				<div class="content-bottom">
					<el-button @click="onQuestionList">글목록</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SupportBanner from '../../components/SupportBanner.vue'
	import request from '@/utils/request';
	export default {
		components: {
			SupportBanner,
		},
		// 如果在路由中设置了 props: true，可以直接接收
		props: ['id'],
		data() {
			return {
				loading: true,
				info: null,
			}
			
		},
		mounted() {
			console.log('mounted当前ID:',this.id)
			
		},
		created() {
			console.log('created当前ID:',this.id)
			this.getDetail()
		},
		methods: {
			getDetail(){
				console.log(this.id,"ID")
				this.loading = true
				request.post('/Question/getQuestionDetail',
					{
						id:this.id,
					}
				).then(res => {
					this.loading = false
					console.log(res.data,"212")
					if(res.code ==1){
						this.info = res.data	
					}
						
				}).catch(() => {
					this.loading = false
				});
				
			},
			onQuestionList(){
				this.$router.push(`/questionList`)
			}
		}
		
	}
</script>

<style scoped>
	.column-center h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 60px 0 0 0;
	    margin: 0 0 60px;
	}
	.content-title{
		font-size: 24px;
		border-top: 2px solid #000;
		text-align: left;
		padding: 13px 15px;
		font-weight: 500;
		/* background-color: #f5f8fd; */
	}
	.content-date{
		padding: 20px 15px;
		color: #6a6a6a;
		border: solid 1px var(--border-color);
		border-width: 1px 0;
	}
	.content{
		padding: 20px 15px;
		border: solid 1px var(--border-color);
		border-width: 0 0 1px 0;
		background-color: var(--frontground-color);
	}
	.content-bottom{
		padding:20px;
		display: flex;
		justify-content: end;
	}
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
</style>